module.exports = __webpack_public_path__ + "static/media/bihimg.8d764f65.png";